import { getEpoch } from "@/contexts/playback-context/helpers";
import { MediaPlayerClass } from "dashjs";

/**
 * Calculates seek value accounting for unreachable segments in the MPD.
 * Used when segments may be missing (e.g., outside timeshift buffer or after recorder restart).
 * Adjusts calculation based on DVR window information rather than assuming all segments are available.
 *
 * @param timestamp - The timestamp to seek to
 * @param mediaPlayerInstance - The dash.js player instance
 * @returns The properly adjusted seek position in seconds relative to DVR window start
 */
export const calculateSeekFromDVRWindowStart = (
  timestamp: Date | number,
  mediaPlayerInstance: MediaPlayerClass
) => {
  return (
    (getEpoch(timestamp) -
      mediaPlayerInstance.getDashAdapter().getAvailabilityStartTime()) /
      1000 -
    mediaPlayerInstance.getDashMetrics().getCurrentDVRInfo().range.start
  );
};
